import './NavBar.css'
import { useNavigate } from 'react-router-dom';
import { logOut } from '../../utilities/services/users';
import SuiteDropdown from '../SuiteDropdown/SuiteDropdown';
import NavProfileDropdown from '../NavProfileDropdown/NavProfileDropdown';
import Notifications from '../Notifications/Notifications';
import Preferences from '../Preferences/Preferences';
// import SearchBar from '../SearchBar/SearchBar';
export default function NavBar({ user, updateUser, isMobile, docketPreferences, setDocketPreferences, updateDocketPreferences }) {
  const navigate = useNavigate()

  

  function handleLogOut(){
    logOut()
    updateUser(null)
    navigate('/')
  }

  const handleDropdownClick = (evt) => {
    // prevent dropdown from closing when clicked
    evt.stopPropagation()
  }

  

  return (
    <nav className='NavBar navbar'>
      <div className='sectionOne'>
        {/* <SearchBar /> */}
      </div>
      <div className='sectionTwo'>
        <div className='sec2p1'>
          <Preferences user={user} updateUser={updateUser} handleDropdownClick={handleDropdownClick}  updateDocketPreferences={updateDocketPreferences} docketPreferences={docketPreferences} setDocketPreferences={setDocketPreferences} />
        </div>
        <div className='sec2p2'>
          <Notifications user={user} updateUser={updateUser} handleDropdownClick={handleDropdownClick} />
        </div>
        <div className='sec2p3'>
          <NavProfileDropdown user={user} handleLogOut={handleLogOut} handleDropdownClick={handleDropdownClick} isMobile={isMobile} />
          <SuiteDropdown user={user} isMobile={isMobile} />
        </div>
      </div>
    </nav>
  );
}